import http from "@/http-common";

export default class MA502120Service {

	getList(_params) {
		//alert("_params = " + JSON.stringify(_params));
		return http.get('/ma/ma502120', { params: _params}).then(res => res.data);
	}

	calculate(_params) {
		return http.get('/ma/ma502120/calculate', { params: _params}).then(res => res.data);
	}

	getOne(_Id) {
		return http.get(`/ma/ma502120/${_Id}`).then(res => res.data);
	}

}